// Copyright (c) 2017 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import AuditFilteredTerritories, {getDefaultState as getFilteredTerritoriesDefaultState} from '../state/audit-filtered-lead-account';
import AuditList, {getDefaultState as getAuditListDefaultState} from './audit-list';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import DealerHierarchyFacet, {getDefaultState as getDealerHierarchyFacetDefaultState} from '../../shared/state/dealer-hierarchy-facet';
import DealerLocationHierarchy, {getDefaultState as getAuditLocationDealerHierarchyState} from '@deere/cps-it.warranty-model-factory/lib/dealer-location-hierarchy';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    auditList: AuditList,
    busyCounter: BusyCounter,
    confirmationModal: ConfirmationModal,
    dealerHierarchyFacet: DealerHierarchyFacet,
    facetFilterText: t.String,
    filteredTerritories: AuditFilteredTerritories,
    initialLoad: t.Bool,
    leadAccount: DealerLocationHierarchy,
    reportsAccordion: Accordion,
    searchFilters: SearchFilters
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        auditList: getAuditListDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        dealerHierarchyFacet: getDealerHierarchyFacetDefaultState(),
        facetFilterText: '',
        filteredTerritories: getFilteredTerritoriesDefaultState(),
        initialLoad: true,
        leadAccount: getAuditLocationDealerHierarchyState(),
        reportsAccordion: getAccordionDefaultState('tcsm-audits-reports-accordion'),
        searchFilters: getSearchFiltersDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/audits/state/index.js